import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Disc3, Music2, Mic2, Guitar, Music, Wand2, Laugh, Radio, Piano, Users, Wine, Camera, ArrowRight } from "lucide-react";
import PublicLayout, { PageHero } from "../components/PublicLayout";
import { useLang } from "../context/LanguageContext";
import { seoCategories } from "../i18n/seoContent";
import { setPageMeta } from "../lib/seo";

const icons = {
  dj: Disc3, band: Music2, singer: Mic2, troubadour: Guitar, saxophonist: Music,
  magician: Wand2, comedian: Laugh, mc: Radio, pianist: Piano, dancer: Users,
  bartender: Wine, photo_booth: Camera,
};

const Categories = () => {
  const { lang } = useLang();
  const isSv = lang === "sv";
  const base = isSv ? "/sv/boka" : "/book";

  useEffect(() => {
    setPageMeta({
      title: isSv ? "Boka talang efter kategori | Talentsio" : "Book talent by category | Talentsio",
      description: isSv ? "Utforska alla talangkategorier du kan boka på Talentsio." : "Explore every talent category you can book on Talentsio.",
      path: isSv ? "/sv/boka" : "/categories",
      enPath: "/categories", svPath: "/sv/boka",
    });
  }, [isSv]);

  return (
    <PublicLayout>
      <PageHero eyebrow={isSv ? "Kategorier" : "Categories"} title={isSv ? "Boka talang efter kategori" : "Book talent by category"}
        subtitle={isSv ? "Välj en kategori för att komma igång, eller skicka en gratis förfrågan direkt." : "Pick a category to get started, or post a free request directly."} />
      <section className="max-w-[1100px] mx-auto px-6 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Object.values(seoCategories).map((c) => {
            const Icon = icons[c.category_id] || Music2;
            const loc = c[isSv ? "sv" : "en"];
            return (
              <Link key={c.slug} to={`${base}/${c.slug}`} className="group rounded-2xl border border-[#2A2A2A] bg-[#181818] p-6 hover:border-[#FF5C00] hover:-translate-y-1 transition-all">
                <div className="flex items-center justify-between">
                  <div className="w-11 h-11 rounded-xl bg-[#FF5C00]/12 flex items-center justify-center"><Icon size={20} className="text-[#FF5C00]" /></div>
                  <ArrowRight size={18} className="text-neutral-600 group-hover:text-[#FF5C00] group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="mt-5 text-[18px] font-semibold text-white capitalize">{loc.name}</h3>
                <p className="mt-2 text-[14px] text-neutral-400 line-clamp-2">{loc.desc}</p>
              </Link>
            );
          })}
        </div>
      </section>
    </PublicLayout>
  );
};

export default Categories;
